// =====================================================
// 📁 POSCategoryList.tsx
// =====================================================

import { Folder } from 'lucide-react';

import { ProductCategory } from '../../../../types/productpanel/ProductCategory';

interface Props {
  scrollRef: React.RefObject<HTMLDivElement>;

  categories: ProductCategory[];

  selectedCategoryId: number | null;

  isSaleInitialized: boolean;

  onCategoryClick: (categoryId: number) => void;
}

const POSCategoryList = ({
  scrollRef,

  categories,

  selectedCategoryId,

  isSaleInitialized,

  onCategoryClick,
}: Props) => {
  return (
    <div
      ref={scrollRef}
      className="
        no-scrollbar

        flex
        min-w-0
        max-w-full

        items-center
        gap-2

        overflow-x-auto
        overflow-y-hidden
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Empty */}
      {/* ===================================================== */}

      {!isSaleInitialized && (
        <div
          className="
            flex
            h-[42px]
            shrink-0
            items-center

            rounded-xl

            border
            border-dashed

            border-slate-300

            bg-white

            px-4

            text-xs
            text-slate-400

            dark:border-form-strokedark
            dark:bg-boxdark-2
            dark:text-bodydark2
          "
        >
          Inicia una venta para mostrar categorías
        </div>
      )}

      {/* ===================================================== */}
      {/* 🔹 Categories */}
      {/* ===================================================== */}

      {isSaleInitialized &&
        categories.map((cat) => {
          const isActive = selectedCategoryId === cat.id;

          return (
            <button
              key={cat.id}
              type="button"
              onClick={() => onCategoryClick(cat.id)}
              className={`
                flex
                h-[42px]

                shrink-0
                items-center
                gap-2

                rounded-xl
                border

                px-4

                text-sm
                font-medium

                transition-all
                duration-200

                ${
                  isActive
                    ? `
                      border-primary
                      bg-primary
                      text-white

                      shadow-2

                      ring-2
                      ring-primary/20
                    `
                    : `
                      border-slate-300
                      bg-white

                      text-slate-600

                      shadow-1

                      hover:border-primary/50
                      hover:bg-primary/10
                      hover:text-primary
                      hover:shadow-2

                      dark:border-form-strokedark
                      dark:bg-boxdark-2
                      dark:text-bodydark2

                      dark:hover:bg-primary/15
                      dark:hover:text-primary
                    `
                }
              `}
            >
              <Folder
                className={`
                  h-4
                  w-4

                  transition-colors
                  duration-200

                  ${isActive ? 'text-white' : 'text-primary'}
                `}
              />

              <span className="whitespace-nowrap">{cat.name}</span>
            </button>
          );
        })}
    </div>
  );
};

export default POSCategoryList;
